export default __webpack_public_path__ + "static/media/link_account.9dd42ecf.svg";